<template>
    <div class="main main-padding">
        <!--基础数据-->
        <Row :gutter="10" style="margin-top: 20px;" class="hw-count">
            <Col :xs="12" :sm="12" :md="8" :lg="4" :xl="4">
                <infor-card
                    id-name="assHomeworkNumber"
                    :end-val="baseData.assHomeworkNumber"
                    iconType="ios-contact"
                    color="#60c0dd"
                    textColor="#39C6E9"
                    intro-text="教师数"
                ></infor-card>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="4" :xl="4">
                <infor-card
                    id-name="assStudent"
                    :end-val="baseData.assStudent"
                    iconType="md-contacts"
                    color="#60c0dd"
                    textColor="#39C6E9"
                    intro-text="学生数"
                ></infor-card>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="4" :xl="4">
                <infor-card
                    id-name="assHomeworkFre"
                    :end-val="baseData.assHomeworkFre"
                    iconType="md-document"
                    color="#39C6E9"
                    textColor="#60c0dd"
                    intro-text="布置作业次数"
                ></infor-card>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="4" :xl="4">
                <infor-card
                    id-name="assHomeworkCount"
                    :end-val="baseData.assHomeworkCount"
                    iconType="ios-paper"
                    color="#39C6E9"
                    textColor="#60c0dd"
                    intro-text="布置作业份数"
                ></infor-card>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="4" :xl="4">
                <infor-card
                    id-name="homeworkSubRate"
                    :end-val="baseData.homeworkSubRate"
                    :decimals="decimals"
                    :options="option"
                    iconType="md-hand"
                    color="#39C6E9"
                    textColor="#60c0dd"
                    intro-text="作业提交率"
                ></infor-card>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="4" :xl="4">
                <infor-card
                    id-name="homeworkCorrRate"
                    :end-val="baseData.homeworkCorrRate"
                    :decimals="decimals"
                    :options="option"
                    iconType="md-star"
                    color="#39C6E9"
                    textColor="#60c0dd"
                    intro-text="作业批改率"
                ></infor-card>
            </Col>
        </Row>
        <!--布置作业日活、周活、月活用户数-->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="12" :sm="12" :md="12" :lg="8" :xl="6" class="hw-active">
                <line-charts
                    :chartsTitle="'智能作业日活用户数'"
                    :chartsId="'hw_day_use'"
                    :lineCompany="'人'"
                    ref="hwDayUse"
                ></line-charts>
            </Col>
            <Col :xs="12" :sm="12" :md="12" :lg="8" :xl="6" class="hw-active">
                <line-charts
                    :chartsTitle="'智能作业周活用户数'"
                    :chartsId="'hw_week_use'"
                    :lineCompany="'人'"
                    ref="hwWeekUse"
                ></line-charts>
            </Col>
            <Col :xs="12" :sm="12" :md="12" :lg="8" :xl="6" class="hw-active">
                <line-charts
                    :chartsTitle="'智能作业月活用户数'"
                    :chartsId="'hw_month_use'"
                    :lineCompany="'人'"
                    ref="hwMonthUse"
                ></line-charts>
            </Col>
        </Row>
        <!--作业学科分析、作业学段分析、各学科布置作业总次数-->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="12" :sm="12" :md="12" :lg="8" :xl="6" class="hw-active">
                <pie-charts
                    :chartsTitle="'作业种类饼图'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'hw_kind'"
                    :pieChartsName="'种类分布'"
                    ref="hwKind"
                ></pie-charts>
            </Col>
            <Col :xs="12" :sm="12" :md="12" :lg="8" :xl="6" class="hw-active">
                <pie-charts
                    :chartsTitle="'作业学段分析'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'hw_stage_analyse'"
                    :pieChartsName="'学段分析'"
                    ref="hwStageAnalyse"
                ></pie-charts>
            </Col>
            <Col :xs="12" :sm="12" :md="12" :lg="8" :xl="6" class="hw-active">
                <histogram-charts
                    :chartsTitle="'各学科布置作业总次数'"
                    :isShowMore=false
                    :isClickCharts=false
                    :isSchool=false
                    :chartsId="'hw_sub_arrange'"
                    :height="'360px'"
                    :histogramTooltip="'useSecond'"
                    ref="hwSubArrange"
                ></histogram-charts>
            </Col>
        </Row>
        <!-- 布置作业top20用户-->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="12" :sm="12" :md="12" :lg="24" :xl="6" class="hw-top">
                <histogram-charts
                    :chartsTitle="'布置作业top20用户'"
                    :isShowMore=false
                    :isClickCharts=false
                    :isSchool=false
                    :chartsId="'hw_user_top'"
                    :height="'360px'"
                    :histogramTooltip="'useSecond'"
                    ref="hwUserTop"
                ></histogram-charts>
            </Col>
        </Row>
        <!-- 各校布置作业次数 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="12" :sm="12" :md="12" :lg="24" :xl="6" class="hw-top">
                <histogram-charts
                    :chartsTitle="'各校布置作业次数'"
                    :isShowMore=false
                    :isClickCharts=false
                    :isSchool=true
                    :chartsId="'hw_school_arrange'"
                    :height="'360px'"
                    :histogramTooltip="'useSecond'"
                    ref="hwSchoolArrange"
                ></histogram-charts>
            </Col>
        </Row>
    </div>
</template>
<script>
    import inforCard from "../../../components/inforCard.vue";
    import HistogramCharts from "../../../components/charts/HistogramCharts.vue";//柱状图
    import PieCharts from "../../../components/charts/PieCharts.vue";//饼状图
    import LineCharts from "../../../components/charts/LineCharts.vue";//折线图
    import {
        findHwUserCount,
        findHomeWorkCount,
        findSubjectName,
        findHwUserCountList,
        findHwSchoolList,
        findHomeWorkLists,
        getTypeOfWork,
        findSubjectMaps
    } from "../../../service/api.js";

    export default {
        name: "homework-main",
        data () {
            return {
                decimals: 2,
                option: {
                    suffix: "%"
                },
                baseData: {
                    //基础数据
                    assHomeworkNumber: 0,
                    assStudent: 0,
                    assHomeworkFre: 0,
                    assHomeworkCount: 0,
                    homeworkSubRate: "",
                    homeworkCorrRate: ""
                }
            };
        },
        components: {
            inforCard,//数据卡片
            HistogramCharts,//柱状图组件
            PieCharts,//饼图组件
            LineCharts//折线图
        },
        methods: {
            /**
             * 获取作业布置人数
             */
            async getHwUserCount () {
                let _this = this;
                await findHwUserCount()
                    .then(function (data) {
                        _this.baseData.assHomeworkNumber = data.count;
                        _this.baseData.assStudent = data.student;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取作业使用率
             */
            async getHomeWorkCount () {
                let _this = this;
                await findHomeWorkCount()
                    .then(function (data) {
                        _this.baseData.assHomeworkFre = data.frequencyCount;
                        _this.baseData.assHomeworkCount = data.counts;
                        _this.baseData.homeworkSubRate = data.submRate;
                        _this.baseData.homeworkCorrRate = data.correRate;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取布置作业日周月活用户数
             */
            async getHomeWorkLists () {
                let _this = this;
                await findHomeWorkLists()
                    .then(function (data) {
                        let userList = data;
                        let dayDataArr = [];
                        let dayNumArr = [];
                        let weekDataArr = [];
                        let weekNumArr = [];
                        let monthDataArr = [];
                        let monthNumArr = [];
                        //日活数据
                        for (let i = 0; i < userList.day.length; i++) {
                            dayDataArr.push(userList.day[i].date);
                            dayNumArr.push(userList.day[i].number);
                        }
                        //周活数据
                        for (let i = 0; i < userList.week.length; i++) {
                            let strWeekStr = userList.week[i].dates.substring(5, 11);
                            let endWeekStr = userList.week[i].dates.substring(16);
                            let weekStr = strWeekStr + endWeekStr;
                            weekDataArr.push(weekStr);
                            weekNumArr.push(userList.week[i].number);
                        }
                        //月活数据
                        for (let i = 0; i < userList.month.length; i++) {
                            monthDataArr.push(userList.month[i].month);
                            monthNumArr.push(userList.month[i].userCount);
                        }
                        _this.$nextTick(() => {
                            //渲染日活图表
                            _this.$refs.hwDayUse.initDataSource(userList.day, dayDataArr, dayNumArr);
                            //渲染周活图表
                            _this.$refs.hwWeekUse.initDataSource(userList.week, weekDataArr, weekNumArr);
                            //渲染月活图表
                            _this.$refs.hwMonthUse.initDataSource(userList.month, monthDataArr, monthNumArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 作业种类饼图
             */
            async findTypeOfWork () {
                let _this = this;
                await getTypeOfWork()
                    .then(function (data) {
                        let subjectList = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < subjectList.length; i++) {
                            let obj = {};
                            //处理数据用于渲染图表
                            obj.value = subjectList[i].count;
                            obj.name = subjectList[i].name;
                            dataArr.push(obj);
                            nameArr.push(subjectList[i].name);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.hwKind.initDataSource(subjectList, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 作业学段分析
             */
            async getSubjectMaps () {
                let _this = this;
                await findSubjectMaps()
                    .then(function (data) {
                        let stageList = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < stageList.length; i++) {
                            let obj = {};
                            //处理数据用于渲染图表
                            obj.value = stageList[i].count;
                            obj.name = stageList[i].class;
                            dataArr.push(obj);
                            nameArr.push(stageList[i].class);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.hwStageAnalyse.initDataSource(stageList, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取各学科布置作业总次数
             */
            async getSubjectName () {
                let _this = this;
                await findSubjectName()
                    .then(function (data) {
                        let subList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < subList.length; i++) {
                            xDataArr.push(subList[i].subName);
                            seriesDataArr.push(subList[i].userCount);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.hwSubArrange.initDataSource(subList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取布置作业top20用户
             */
            async getHwUserCountList () {
                let _this = this;
                await findHwUserCountList()
                    .then(function (data) {
                        let userList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < userList.length; i++) {
                            if (i < 20) {
                                xDataArr.push(userList[i].display_name);
                                seriesDataArr.push(userList[i].count);
                            }
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.hwUserTop.initDataSource(userList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取布置作业top20学校
             */
            async getHwSchoolList () {
                let _this = this;
                await findHwSchoolList()
                    .then(function (data) {
                        let schList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < schList.length; i++) {
                            if (i < 20) {
                                xDataArr.push(schList[i].schoolName);
                                seriesDataArr.push(schList[i].count);
                            }
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.hwSchoolArrange.initDataSource(schList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
        },
        mounted () {
            this.$store.commit("SET_TOPHEADERNAME", "作业详情统计");
            //获取作业布置人数
            this.getHwUserCount();
            //获取作业使用率
            this.getHomeWorkCount();
            //获取布置作业日周月活用户数
            this.getHomeWorkLists();
            //作业种类饼图
            this.findTypeOfWork();
            //作业学段分析
            this.getSubjectMaps();
            //获取各学科布置作业总次数
            this.getSubjectName();
            //获取布置作业top20用户
            this.getHwUserCountList();
            //获取布置作业top20学校
            this.getHwSchoolList();
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../style/home";

    .hw-count {
        @media (min-width: 1200px) {
            .ivu-col-span-lg-4 {
                display: block;

            }
        }
    }

    .hw-active.ivu-col-span-xl-6 {
        width: 33.33%;
    }

    .hw-top.ivu-col-span-xl-6 {
        width: 100%;
    }
</style>
